import { render, staticRenderFns } from "./batchSelectModal.vue?vue&type=template&id=1ff82547&scoped=true"
import script from "./batchSelectModal.vue?vue&type=script&lang=js"
export * from "./batchSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff82547",
  null
  
)

export default component.exports